import React,{useState, useEffect} from 'react';
// import {browserHistory} from "react-router";
import { useDispatch } from "react-redux";
import * as actions from '../../actions/reservations';

import * as seminar_request_actions from '../../actions/seminar_requests';
import * as task_actions from '../../actions/tasks';

import { BellOutlined, EyeInvisibleOutlined, EyeInvisibleTwoTone, EyeOutlined, EyeTwoTone, } from '@ant-design/icons';
import { Badge, Divider, List, Skeleton, Button, Typography } from 'antd';
import api from '../../middleware/api';
import moment from 'moment';
import InfiniteScroll from 'react-infinite-scroll-component';
import '../../stylesheets/App.scss';

import { Link } from 'react-router-dom';

const { Title } = Typography;



const propTypes = {};
const defaultProps = {};

// let notificationsList = []; 
let pageNotif = 0
let dataList = [] ;

const NotificationWidget = (props) => {
    //const [notificationsList, setNotificationsList] = useState([]);
    const [dropdownState, setDropdownState] = useState(false);
    const [notificationsCounter, setNotificationsCounter] = useState(0);
    const [notificationsCounterAll, setNotificationsCounterAll] = useState(0);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const dispatch = useDispatch();
    // const loadMoreData = () => {
    //     if (loading) {
    //       return;
    //     }
    //     setLoading(true);
    //     fetch('https://randomuser.me/api/?results=1&inc=name,gender,email,nat,picture&noinfo')
    //       .then((res) => res.json())
    //       .then((body) => {
    //         setData([...data, ...body.results]);
    //         setLoading(false);
    //       })
    //       .catch(() => {
    //         setLoading(false);
    //       });
    // };
    const loadMoreData = () => {
        pageNotif = pageNotif + 1
        // console.log('pageNotif', pageNotif)
        //setPageState(page)
        //setPageState(pageState+1);
        if (loading) {
            return;
        }
        setLoading(true);
        api.get(`/notifications?page=${pageNotif}&limit=10`).then(response => {
            if(response.data){
                //console.log('response', response.data)
                if(response.data.success == true){
                    const notifsList = createDropdownList(response.data.data)
                    // console.log('notifsList', notifsList)
                    //notificationsList = notifsList;
                    setNotificationsCounter(response.data.counter)
                    setNotificationsCounterAll(response.data.counterAll)
                    dataList = [...dataList, ...notifsList];
                    setData(dataList)
                    setLoading(false);
                    //browserHistory.push("/");
                }else{
                  setLoading(false)
                }
            }
            
        }).catch(error => {
            setLoading(false)
        });
    };
    
    
    const updateNotification = (id,reservation) => {
        // console.log('reservation', reservation)
        // console.log('data', data)
        const dataFiltered = data.filter((element) => { return element.key == id })
        const is_read = dataFiltered[0]['is_read']

        if(!is_read){
            api.put(`/notifications`,{
                id:id,
                is_read:1
            }).then(response => {
                if (response.data.success) {
                    const notificationsListNew =  dataList.map((item) => {
                        if(item['key'] && item['key'] == id){
                            item['is_read'] = 1;
                        }
                        return item;
                    });
                    dataList = notificationsListNew;
                    setData(dataList)
                    setNotificationsCounter(count => {if(count>0){ return count - 1 }})
                }
            });
        }
        dispatch(actions.default.fetch(`reservations_${reservation}`, { _id: reservation }, { isAsync: false } ));
        dispatch(seminar_request_actions.default.fetch(`seminar_requests`, { seminar_request_id: reservation }, { isAsync: false } ));
        dispatch(task_actions.default.fetch(`tasks`, { _id: reservation }, { isAsync: false } ));
    }

    

    
    const createDropdownList = (notifs) => {
        const notifsList = notifs.map(element => {
            let newElement = {};
            newElement['key'] = element.user_notifications.id;
            newElement['message'] = element.messages.content
            newElement['reservation_id'] = element.reservation_id
            newElement['notification_type'] = element.notification_type
            newElement['created'] = moment(element.created)
            newElement['is_read'] = element.user_notifications.is_read
            switch (element.notification_type) {
                case 'reservation':
                    newElement['link'] = `/reservations/${element.reservation_id}`
                    break;
                case 'seminar_request':
                    newElement['link'] = `/seminar_requests/home?seminar_request_id=${element.reservation_id}`
                    break;
                case 'training':
                    newElement['link'] = `/trainings/${element.reservation_id}`
                    break;
                case 'manage_reservation':
                    newElement['link'] = `/reservations/${element.reservation_id}`
                    break;
                case 'training_review':
                    newElement['link'] = `/trainings/${element.reservation_id}`
                    break;
                case 'manage_training':
                    newElement['link'] = `/trainings/${element.reservation_id}`
                    break;
                default:
                    // code to be executed if expression doesn't match any case
              }
            
            return newElement;
        })
        return notifsList;
    }
    const handleClickOutside = (event) => {
        //var path = event.path || (event.composedPath && event.composedPath());
        const divs =  event.path || (event.composedPath && event.composedPath());
        // console.log('divs', divs)
        let found = false
        divs.map((element) => {
            if(element.className == "dropdown"){
                found = true;
            }
        })
        if(!found){
            if(!divs.includes('div#scrollableDiv')){
                setDropdownState(false)
            }
        }
        
    }
    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        loadMoreData();
        const timer = setInterval(() => {
            api.get(`/notifications_last`).then(response => {
                if(response.data){
                    if(response.data.success == true){
                        const notifsList = createDropdownList(response.data.data)
                        setNotificationsCounter(response.data.counter)
                        setNotificationsCounterAll(response.data.counterAll)
                        dataList = [...notifsList,  ...dataList ] ;
                        setData(dataList)
                        // setNotifications(notificationsList);
                    }else{
                        
                    }
                }
               
            }).catch(error => {
               
            });
        }, 20000);
        // return () => clearTimeout(timer);
        
    }, [])

    
    const handleClick = () => {
        setDropdownState(!dropdownState)
    }

    const markAllAsRead = () => {
        api.put(`/notifications_read`, {

        }).then(response => {
            if (response.data.success) {
                const notificationsListNew =  dataList.map((item) => {
                    item['is_read'] = 1;
                    return item;
                });
                dataList = notificationsListNew;
                setData(dataList)
                setNotificationsCounter(0)
            }
        });
    }

    const markAsUnread = (id) => {
        api.put(`/notifications`,{
            id:id,
            is_read:0
        }).then(response => {
            if (response.data.success) {
                const notificationsListNew =  dataList.map((item) => {
                    if(item['key'] && item['key'] == id){
                        item['is_read'] = 0;
                    }
                    return item;
                });
                dataList = notificationsListNew;
                setData(dataList)
                setNotificationsCounter(count => {return count + 1 })
                // setNotifications(notificationsList);
            }
        });
    }

    const markAsRead = (id) => {
        api.put(`/notifications`,{
            id:id,
            is_read:1
        }).then(response => {
            if (response.data.success) {
                const notificationsListNew =  dataList.map((item) => {
                    if(item['key'] && item['key'] == id){
                        item['is_read'] = 1;
                    }
                    return item;
                });
                dataList = notificationsListNew;
                setData(dataList)
                setNotificationsCounter(count => {if(count>0){ return count - 1 }})
                // setNotifications(notificationsList);
            }
        });
    }

    // useEffect(() => {
    //     loadMoreData();
    // }, []);

    return (
        <React.Fragment>
            <div className={`dropdown`} id={`dropdown`}>
                <Badge onClick={() => handleClick()}  count={notificationsCounter}>
                    <BellOutlined style={{fontSize: '23px'}} />
                </Badge>
                <div
                    className={`dropdown-items ${
                        dropdownState ? "isVisible" : "isHidden"
                    }`}>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px' }}>
                        <Title style={{marginBottom: '0'}} level={5}>Ενημερώσεις</Title>   
                        <Link  style={{marginLeft: '5px',  lineHeight: 'normal'}} to={`/notifications/home`}>Προβολή όλων</Link>
                    </div>        
                    <div
                        id="scrollableDiv"
                        style={{
                            height: 400,
                            overflow: 'auto',
                            padding: '0 0px',
                            border: '1px solid rgba(140, 140, 140, 0.35)',
                        }}
                        >
                       
                        <InfiniteScroll
                            dataLength={data.length}
                            next={loadMoreData}
                            hasMore={ data.length < notificationsCounterAll }
                            loader={<Divider plain><Skeleton.Input active={true} size={`default`} /></Divider>}
                            //loader={<Skeleton.Input active={true} size={`default`} />}
                            endMessage={<Divider plain>Δεν έχετε άλλες ειδοποιήσεις</Divider>}
                            scrollableTarget="scrollableDiv"
                        >
                            <List
                            
                            dataSource={data}
                            renderItem={(item) => {
                                return (<List.Item style={{padding: '10px 10px', textAlign:"left"}} className={item.is_read ? ``: `is_read` } key={item.key}>
                                    <div style={{display:'flex'}}>
                                        {item.is_read ?<EyeTwoTone  onClick={() => {markAsUnread(item.key)}}/> :<EyeInvisibleTwoTone onClick={() => {markAsRead(item.key)}} /> }
                                        
                                        <Link  style={{marginLeft: '5px'}} onClick={() => {updateNotification(item.key, item.reservation_id)}} to={item.link}> 
                                            
                                            <div className="content">
                                                <div className="title">{item.message}</div>
                                                <div className='date'> {item.created.format("DD/MM/YYYY HH:mm")}</div>
                                            </div>
                                            
                                        </Link>
                                    </div>
                                                                   
                                </List.Item>
                                )
                            }}
                            />
                        </InfiniteScroll>
                    </div>
                    <Button type="primary" block onClick={markAllAsRead} >
                        Σήμανση όλων ως αναγνωσμένων
                    </Button>
                </div>
            </div>
        </React.Fragment>
    );
}

NotificationWidget.propTypes = propTypes;
NotificationWidget.defaultProps = defaultProps;

export default NotificationWidget;